import { render, staticRenderFns } from "./LandingPageSetting.vue?vue&type=template&id=65ea9b04&scoped=true&"
import script from "./LandingPageSetting.vue?vue&type=script&lang=ts&"
export * from "./LandingPageSetting.vue?vue&type=script&lang=ts&"
import style0 from "./LandingPageSetting.vue?vue&type=style&index=0&id=65ea9b04&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ea9b04",
  null
  
)

export default component.exports